import ApiService from '@/core/services/api.service';

const BASE_URL = 'preorder-histories';

const PreorderHistoryService = {
  getList(preorderId, params = {}) {
    return ApiService.query(BASE_URL, {
      params: { preorderId, getFull: true, ...params },
    });
  },

  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },
};

export default PreorderHistoryService;
